import { OnInit, OnChanges, AfterViewInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
var LargeInputComponent = /** @class */ (function () {
    function LargeInputComponent(cdr) {
        this.cdr = cdr;
        this.required = false;
        this.inputValue = '';
        this.disabled = false;
        this.prefix = null;
        this.isLoading = false;
        this.ariaDescribedby = null;
        this.readonly = false;
        this.isFilled = false;
        this.isFocused = false;
        // Function to call when the rating changes.
        this.onChange = function (value) { };
        // Function to call when the input is touched (when a star is clicked).
        this.onTouched = function () { };
    }
    Object.defineProperty(LargeInputComponent.prototype, "content", {
        set: function (content) {
            this.prefixElem = content;
        },
        enumerable: true,
        configurable: true
    });
    LargeInputComponent.prototype.ngOnInit = function () {
        this.TAP_checkIfFilled();
    };
    LargeInputComponent.prototype.ngOnChanges = function () {
        this.TAP_checkIfFilled();
    };
    LargeInputComponent.prototype.TAP_checkIfFilled = function () {
        if (this.inputValue !== '') {
            this.isFilled = true;
        }
        else {
            this.isFilled = false;
        }
    };
    LargeInputComponent.prototype.ngAfterViewInit = function () {
        this.cdr.detectChanges();
    };
    LargeInputComponent.prototype.change = function ($event) {
        this.inputValue = $event.target.value;
    };
    LargeInputComponent.prototype.TAP_printID = function () {
        return this.id;
    };
    LargeInputComponent.prototype.TAP_printIcon = function () {
        return this.icon;
    };
    LargeInputComponent.prototype.TAP_printLabel = function () {
        return this.placeholderLabel && !this.isFilled ? this.placeholderLabel : this.label;
    };
    LargeInputComponent.prototype.TAP_printStyle = function () {
        return {
            'is-filled': this.isFilled && !this.isLoading,
            'is-loading': this.isLoading,
            'is-focused': this.isFocused,
            'is-disabled': this.disabled && !this.isLoading,
            'has-error': this.hasError,
            'has-icon': this.icon
        };
    };
    LargeInputComponent.prototype.TAP_printPadding = function () {
        if (this.prefix === null || this.prefixElem === undefined) {
            return null;
        }
        else {
            return {
                paddingLeft: (this.prefixElem.nativeElement.offsetWidth + 4) + 'px'
            };
        }
    };
    LargeInputComponent.prototype.TAP_handleFocus = function ($event) {
        this.isFocused = true;
    };
    LargeInputComponent.prototype.TAP_handleBlur = function ($event) {
        this.isFocused = false;
        if ($event.target.value !== '') {
            this.isFilled = true;
        }
        else {
            this.isFilled = false;
        }
        this.writeValue($event.target.value);
    };
    LargeInputComponent.prototype.TAP_showError = function () {
        return this.hasError;
    };
    // Allows Angular to update the model (rating).
    // Update the model and changes needed for the view here.
    LargeInputComponent.prototype.writeValue = function (value) {
        this.onChange(value);
    };
    // Allows Angular to register a function to call when the model (rating) changes.
    // Save the function as a property to call later here.
    LargeInputComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    LargeInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // Allows Angular to disable the input.
    LargeInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    LargeInputComponent.prototype.TAP_printError = function () {
        return this.errorMessage;
    };
    LargeInputComponent.prototype.TAP_isRequired = function () {
        return this.required;
    };
    return LargeInputComponent;
}());
export { LargeInputComponent };
